import { StyleSheet, View } from 'react-native';
import { Typography } from 'ucl/components/text/Typography';

import ActionButton from 'components/action-button';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';
import { LayoutWidth } from 'styles/constants/enums';

import { useStartOrderFromAccountDrawer } from './use-start-order-from-account-drawer';

export const StartOrderEmptyState = () => {
  const startOrder = useStartOrderFromAccountDrawer();

  return (
    <View style={styles.emptyState}>
      <Typography accessibilityLevel={1} style={styles.header} variant="headerOne">
        {t('noOrdersItemsYet')}
      </Typography>
      <Typography style={styles.subheader} variant="copyOne">
        {t('recentOrdersEmptySubHeader')}
      </Typography>
      <ActionButton onPress={startOrder}>{t('startOrder')}</ActionButton>
    </View>
  );
};

const styles = StyleSheet.create({
  emptyState: {
    alignItems: 'center',
    flexDirection: 'column',
    maxWidth: LayoutWidth.SMALL,
    width: '83.333%',
  },
  header: {
    color: primitive.$greyOne,
    fontFamily: 'heading',
    fontSize: 30,
    lineHeight: 36,
    marginBottom: 0,
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  subheader: {
    marginBottom: 32,
    marginHorizontal: 0,
    marginTop: 16,
    textAlign: 'center',
  },
});
